import { Pipe, PipeTransform } from '@angular/core';

import { identificadoresMatrizFilial } from '../identificador-matriz-filial';

@Pipe({
    name: 'identificadorMatrizFilialBadge'
})
export class IdentificadorMatrizFilialBadgePipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = identificadoresMatrizFilial.findIndex(Situacao => Situacao.id === value);
        if (index > -1) {
            return identificadoresMatrizFilial[index].badge;
        }
        return '';
    }
}
